module.exports = __webpack_public_path__ + "LA.png?2856a6dbb239299bc46f7ca38eb6f6e1";